"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsError = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var RaisedButton_1 = __importDefault(require("@atg/icf-react-components/components/RaisedButton"));
var react_jss_1 = require("react-jss");
var useSearchResultsErrorStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    searchResultsErrorLayout: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        width: "100%",
        height: "100%",
    },
    searchResultsErrorPanel: {
        borderWidth: theme.spacing.base / 4,
        borderStyle: "solid",
        borderColor: theme.colors.baseContrast050,
        padding: "".concat(theme.spacing.base * 5.25, "px ").concat(theme.spacing.base * 6, "px"),
        margin: "".concat(theme.spacing.base * 6, "px ").concat(theme.spacing.base * 2, "px"),
        color: theme.colors.baseContrast090,
        backgroundColor: theme.colors.baseContrast020,
    },
    searchResultsErrorTitle: {
        fontSize: theme.spacing.base * 3,
    },
    searchResultsErrorMessage: {
        fontSize: theme.spacing.base * 1.75,
        padding: "".concat(theme.spacing.base * 3, "px 0"),
    },
    searchResultsErrorButtons: {
        display: "flex",
        justifyContent: "center",
    },
    tryAgainButtonContainer: {
        width: "calc(50% - ".concat(theme.spacing.base * 2, "px)"),
        height: "100%",
    },
}); });
var SearchResultsError = function (_a) {
    var onTryAgainClicked = _a.onTryAgainClicked, translate = _a.translate;
    var classes = useSearchResultsErrorStyles();
    return ((0, jsx_runtime_1.jsx)("div", { className: classes.searchResultsErrorLayout, children: (0, jsx_runtime_1.jsxs)("div", { className: classes.searchResultsErrorPanel, children: [(0, jsx_runtime_1.jsx)("div", { className: classes.searchResultsErrorTitle, children: translate("search.error_title") }), (0, jsx_runtime_1.jsx)("div", { className: classes.searchResultsErrorMessage, children: translate("search.error_message") }), (0, jsx_runtime_1.jsx)("div", { className: classes.searchResultsErrorButtons, children: (0, jsx_runtime_1.jsx)("div", { className: classes.tryAgainButtonContainer, children: (0, jsx_runtime_1.jsx)(RaisedButton_1.default, { "data-ta-locator": "SearchResultsErrorButton", label: translate("search.try_again"), onClick: onTryAgainClicked, size: "large", fullWidth: true }) }) })] }) }));
};
exports.SearchResultsError = SearchResultsError;
exports.SearchResultsError.displayName = "SearchResultsError";
//# sourceMappingURL=SearchResultsError.js.map